import "../node_modules/css-preflight/styles/preflight.css";
import "../node_modules/css-preflight/styles/smooth-scroll.css";
import "../node_modules/css-preflight/styles/text-wrap-balance.css";

import "../scss/screen.scss";

import $ from "jquery";
import "@accessible360/accessible-slick";
import loadjs from "loadjs";
import {UAParser} from "ua-parser-js";

// Accessible Slick 1.0.1 still calls jQuery.type(), which was removed in jQuery 4.
if (typeof $.type !== "function") {
    $.type = (value) => {
        if (value === null) {
            return "null";
        }

        if (value === undefined) {
            return "undefined";
        }

        if (Array.isArray(value)) {
            return "array";
        }

        return typeof value;
    };
}

Object.assign(window, {
    $,
    jQuery: $,
    loadjs,
    UAParser,
    klaro: window.klaro,
});

document.addEventListener("DOMContentLoaded", () => {
    const backToTop = document.querySelector(".back-to-top");

    if (backToTop) {
        const updateBackToTopVisibility = () => {
            backToTop.classList.toggle("is-visible", window.scrollY > 240);
        };

        window.addEventListener("scroll", updateBackToTopVisibility, {passive: true});
        updateBackToTopVisibility();

        backToTop.addEventListener("click", () => {
            window.scrollTo({
                top: 0,
                behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
            });
        });
    }

    const counters = document.querySelectorAll("[data-fact-counter]");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (!reducedMotion) {
        const numberFormatter = new Intl.NumberFormat("de-DE", {useGrouping: false});
        const animateCounter = (counter) => {
            const start = Number.parseInt(counter.dataset.counterStart, 10);
            const end = Number.parseInt(counter.dataset.counterEnd, 10);

            if (Number.isNaN(start) || Number.isNaN(end)) {
                return;
            }

            const minimumDigits = Number.parseInt(counter.dataset.counterMinDigits, 10) || 1;
            const formatValue = (value) => numberFormatter
                .format(value)
                .padStart(minimumDigits, "0");

            counter.textContent = formatValue(start);
            const startedAt = performance.now();
            const duration = 1400;

            const update = (now) => {
                const progress = Math.min((now - startedAt) / duration, 1);
                const easedProgress = 1 - Math.pow(1 - progress, 3);
                const value = Math.round(start + ((end - start) * easedProgress));
                counter.textContent = formatValue(value);

                if (progress < 1) {
                    window.requestAnimationFrame(update);
                } else {
                    counter.textContent = formatValue(end);
                }
            };

            window.requestAnimationFrame(update);
        };

        counters.forEach((counter) => {
            if (counter.dataset.counterTrigger === "load") {
                animateCounter(counter);
            }
        });

        if ("IntersectionObserver" in window) {
            const counterObserver = new IntersectionObserver((entries, observer) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) {
                        return;
                    }

                    const counter = entry.target;
                    animateCounter(counter);
                    observer.unobserve(counter);
                });
            }, {threshold: 0.5});

            counters.forEach((counter) => {
                if (counter.dataset.counterTrigger !== "load") {
                    counterObserver.observe(counter);
                }
            });
        }
    }

    document.querySelectorAll("[data-refcat-dialog]").forEach((dialog) => {
        const section = dialog.closest(".el-refcat");
        const content = dialog.querySelector("[data-refcat-dialog-content]");
        let opener = null;
        let requestNumber = 0;

        if (!section || !content || typeof dialog.showModal !== "function") {
            return;
        }

        const waitForImages = (container) => Promise.all(
            Array.from(container.querySelectorAll("img:not([loading=\"lazy\"])")).map((image) => {
                if (typeof image.decode === "function") {
                    return image.decode().catch(() => undefined);
                }

                if (image.complete) {
                    return Promise.resolve();
                }

                return new Promise((resolve) => {
                    image.addEventListener("load", resolve, {once: true});
                    image.addEventListener("error", resolve, {once: true});
                });
            })
        );

        const updateDialogURL = (entry) => {
            const url = new URL(window.location.href);

            if (entry) {
                url.searchParams.set("referenz", entry);
            } else {
                url.searchParams.delete("referenz");
            }

            window.history.replaceState({}, "", url);
        };

        section.querySelectorAll("[data-refcat-dialog-open]").forEach((link) => {
            link.addEventListener("click", async (event) => {
                event.preventDefault();
                opener = link;
                updateDialogURL(link.dataset.refcatDialogEntry);
                requestNumber += 1;
                const currentRequest = requestNumber;

                dialog.removeAttribute("aria-labelledby");
                content.innerHTML = "";

                try {
                    const response = await fetch(link.href, {
                        credentials: "same-origin",
                        headers: {"X-Requested-With": "XMLHttpRequest"},
                    });

                    if (!response.ok) {
                        throw new Error("Der Referenzeintrag konnte nicht geladen werden.");
                    }

                    const html = await response.text();
                    if (currentRequest !== requestNumber) {
                        return;
                    }

                    content.innerHTML = html;
                    await waitForImages(content);

                    const contentScroll = content.querySelector(".el-refcat__dialog-content-scroll");
                    if (contentScroll) {
                        const updateContentFade = () => {
                            const hasOverflow = contentScroll.scrollHeight > contentScroll.clientHeight + 1;
                            const isAtBottom = contentScroll.scrollTop + contentScroll.clientHeight >= contentScroll.scrollHeight - 1;
                            contentScroll.classList.toggle("has-overflow", hasOverflow);
                            contentScroll.classList.toggle("is-at-bottom", isAtBottom);
                        };

                        contentScroll.addEventListener("scroll", updateContentFade, {passive: true});
                        requestAnimationFrame(updateContentFade);
                    }

                    if (currentRequest !== requestNumber) {
                        return;
                    }

                    const $imageSlider = $(content).find(".el-refcat__dialog-images");

                    if ($imageSlider.children(".el-refcat__dialog-image").length > 1) {
                        try {
                            $imageSlider.slick({
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                infinite: false,
                                arrows: true,
                                arrowsPlacement: "afterSlides",
                                dots: false,
                                autoplay: false,
                                adaptiveHeight: true,
                                regionLabel: "Bildergalerie",
                                instructionsText: "Mit den vorherigen und nächsten Schaltflächen können Sie durch die Bilder navigieren.",
                                prevArrow: '<button class="slick-prev" type="button"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M15.0014 6.99952H4.15741L8.26441 2.14552L6.73841 0.853516L0.691406 7.99952L6.73841 15.1455L8.26441 13.8535L4.15741 8.99952H15.0014V6.99952Z" fill="currentColor"/></svg><span class="slick-sr-only">Vorheriges Bild</span></button>',
                                nextArrow: '<button class="slick-next" type="button"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M15.0014 6.99952H4.15741L8.26441 2.14552L6.73841 0.853516L0.691406 7.99952L6.73841 15.1455L8.26441 13.8535L4.15741 8.99952H15.0014V6.99952Z" fill="currentColor"/></svg><span class="slick-sr-only">Nächstes Bild</span></button>',
                            });

                            const slick = $imageSlider.slick("getSlick");
                            const $counter = $("<p class=\"el-refcat__dialog-slider-count t-caption\" aria-live=\"polite\"></p>").appendTo($imageSlider);
                            const updateSliderCount = (currentSlide) => {
                                const current = currentSlide + 1;
                                $counter
                                    .attr("aria-label", `Bild ${current} von ${slick.slideCount}`)
                                    .text(`${current} / ${slick.slideCount}`);
                            };

                            updateSliderCount(slick.currentSlide);
                            $imageSlider.on("afterChange.referenzSlider", (event, instance, currentSlide) => {
                                updateSliderCount(currentSlide);
                            });
                        } catch (error) {
                            console.error("Referenz-Slider konnte nicht initialisiert werden.", error);
                        }
                    }

                    dialog.removeAttribute("aria-label");
                    dialog.setAttribute("aria-labelledby", "referenz-eintrag-dialog-title");
                    dialog.setAttribute("aria-busy", "false");
                    dialog.showModal();
                    document.body.classList.add("has-refcat-dialog-open");
                    content.querySelector(".el-refcat__dialog-title")?.focus();
                } catch (error) {
                    if (currentRequest === requestNumber) {
                        content.innerHTML = '<p role="alert">Der Referenzeintrag konnte nicht geladen werden.</p>';
                        dialog.setAttribute("aria-label", "Referenzeintrag");
                        dialog.setAttribute("aria-busy", "false");
                        dialog.showModal();
                        document.body.classList.add("has-refcat-dialog-open");
                    }
                } finally {
                    if (currentRequest === requestNumber) {
                        dialog.setAttribute("aria-busy", "false");
                    }
                }
            });
        });

        content.addEventListener("click", (event) => {
            if (event.target.closest("[data-refcat-dialog-close]")) {
                dialog.close();
            }
        });

        dialog.querySelector("[data-refcat-dialog-close]")?.addEventListener("click", () => {
            dialog.close();
        });

        dialog.addEventListener("click", (event) => {
            if (event.target === dialog) {
                dialog.close();
            }
        });

        dialog.addEventListener("close", () => {
            document.body.classList.remove("has-refcat-dialog-open");
            content.innerHTML = "";
            updateDialogURL(null);
            opener?.focus();
        });

        const entryFromURL = new URLSearchParams(window.location.search).get("referenz");
        const matchingLink = entryFromURL
            ? Array.from(section.querySelectorAll("[data-refcat-dialog-entry]")).find(
                (link) => link.dataset.refcatDialogEntry === entryFromURL
            )
            : null;

        matchingLink?.click();
    });

    const toggle = document.getElementById("menu-toggle");
    const menu = document.getElementById("mobnav-wrapper");
    const closeButton = document.querySelector(".close-mobile-nav");
    const submenuBackButton = document.querySelector(".header__submenu-back");

    if (!toggle || !menu) {
        return;
    }

    let closeTimer;
    let submenuTimer;
    let activeSubmenu;

    const hideSubmenu = (submenu) => {
        if (!submenu) {
            return;
        }

        submenu.classList.remove("is-visible");
        window.clearTimeout(submenuTimer);
        submenuTimer = window.setTimeout(() => {
            if (!submenu.classList.contains("is-visible")) {
                submenu.hidden = true;
            }
        }, 400);
    };

    const closeSubmenu = () => {
        if (!activeSubmenu) {
            return;
        }

        const trigger = menu.querySelector(`[aria-controls="${activeSubmenu.id}"]`);
        trigger?.setAttribute("aria-expanded", "false");
        hideSubmenu(activeSubmenu);
        activeSubmenu = null;
    };

    const openSubmenu = (trigger) => {
        const submenu = document.getElementById(trigger.getAttribute("aria-controls"));
        if (!submenu) {
            return;
        }

        if (activeSubmenu && activeSubmenu !== submenu) {
            hideSubmenu(activeSubmenu);
        }

        window.clearTimeout(submenuTimer);
        submenu.hidden = false;
        trigger.setAttribute("aria-expanded", "true");
        activeSubmenu = submenu;
        window.requestAnimationFrame(() => submenu.classList.add("is-visible"));
    };

    const openCurrentMenuLocation = () => {
        const currentLink = menu.querySelector(
            'a[aria-current="page"], a.current'
        ) || menu.querySelector(".mob-nav__primary__subnav__link.section");
        const submenu = currentLink?.closest(".mob-nav__primary__sub");

        if (submenu) {
            const trigger = menu.querySelector(`[aria-controls="${submenu.id}"]`);

            if (trigger) {
                openSubmenu(trigger);
                window.requestAnimationFrame(() => {
                    currentLink.scrollIntoView({block: "center"});
                });
            }

            return;
        }

        currentLink?.scrollIntoView({block: "center"});
    };

    const setMenuState = (isOpen) => {
        toggle.setAttribute("aria-expanded", String(isOpen));
        toggle.setAttribute("aria-label", isOpen ? "Menü schließen" : "Menü öffnen");
        toggle.classList.toggle("hamburger-open", isOpen);
        document.body.classList.toggle("menu-open", isOpen);

        window.clearTimeout(closeTimer);

        if (isOpen) {
            menu.hidden = false;
            window.requestAnimationFrame(() => {
                menu.classList.add("open");
                openCurrentMenuLocation();
            });
        } else {
            menu.classList.remove("open");
            closeSubmenu();
            closeTimer = window.setTimeout(() => {
                if (!menu.classList.contains("open")) {
                    menu.hidden = true;
                }
            }, 400);
        }

        if (!isOpen) {
            toggle.focus();
        }
    };

    toggle.addEventListener("click", () => {
        setMenuState(toggle.getAttribute("aria-expanded") !== "true");
    });

    closeButton?.addEventListener("click", () => setMenuState(false));
    submenuBackButton?.addEventListener("click", closeSubmenu);

    menu.querySelectorAll(".mob-nav__primary__link-open").forEach((trigger) => {
        trigger.addEventListener("click", () => openSubmenu(trigger));
    });

    menu.querySelectorAll(".primary__close").forEach((button) => {
        button.addEventListener("click", closeSubmenu);
    });

    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && toggle.getAttribute("aria-expanded") === "true") {
            if (activeSubmenu) {
                closeSubmenu();
            } else {
                setMenuState(false);
            }
        }
    });
});
